import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiWhatsNewData = () => {
    const { allStrapiResource } = useStaticQuery(graphql`
        query {
            allStrapiResource(filter: {title: {regex: "/Training and Technical Assistance Resource Catalog/"}})  {
                nodes {
                  card_title
                  title
                  author
                  resource_date(formatString: "YYYY")
                  slug
                  external_url_resource
                  external_resource
                  external_file_size
                  thumbnail {
                    alternativeText
                    localFile {
                        childImageSharp {
                            gatsbyImageData(width: 205 height: 265)
                        }
                    }
                }
                body {
                    data {
                      childMarkdownRemark {
                        html
                        rawMarkdownBody
                        excerpt(format: PLAIN, pruneLength: 85)
                        }
                    }
                }
                pdf {
                    name
                    localFile {
                      prettySize
                    }
                  }
              }
            }
        }
      `)
    return { allStrapiResource }
}